<script>
export default ({
  name: 'ProductSuggestion',
  props: ['product'],
});
</script>

<template>
  <div v-if="product.suggested_products && product.suggested_products.length > 0">
    <div class="font-semibold pb-2 border-b">{{ $t('suggested_products') }}</div>
    <div class="pt-4 w-full h-full text-base grid grid-cols-3 gap-4">
      <a
        :href="suggestedProduct.url"
        target="_blank"
        class="bg-gray-diagomics px-6 py-2 rounded-md text-sm
          text-blue-diagomics-light flex items-center"
        v-for="suggestedProduct in product.suggested_products"
      :key="suggestedProduct.id"
      >
        <span>{{ suggestedProduct.displayed_name }}</span>
      </a>
    </div>
  </div>
</template>
